import classes from "./Popup.module.scss";
import { ReactComponent as CheckIcon } from "@assets/images/circle-check.svg";
import { useTranslation } from "react-i18next";

type Props = {
  onClose: () => void;
};
const Popup = ({ onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={classes.wrapper} onClick={onClose}>
      <div className={classes.popup} onClick={(e) => e.stopPropagation()}>
        <div className={classes.popup__icon}>
          <CheckIcon />
        </div>
        <h2>{t("popup.title")}</h2>
        <p>{t("popup.subtitle")}</p>
        <button onClick={onClose}>{t("popup.button")}</button>
      </div>
    </div>
  );
};

export default Popup;
